import React, { useEffect, useState } from "react";
import { Button, Container, Row } from 'react-bootstrap';
import { Link, NavLink } from "react-router-dom";
import { FaArrowUp } from "react-icons/fa6";
import instagram from "../Assets/instagram.png";
import twitter from "../Assets/x.png";
import telegram from "../Assets/telegram.png";
import youtube from "../Assets/youtube.png";
import facebook from "../Assets/facebook.png";
import edafacelogo from "../Assets/edaface-logo1.png"
import chatforum from "../Assets/chatForum.png";
import discord from "../Assets/discord.png";
import reddit from "../Assets/reddit.png";
import tiktok from "../Assets/tik-tok.png";
import { IoSend } from "react-icons/io5";
import { useSelector , useDispatch } from "react-redux";
import { isEmpty } from "../helper/common";
import { toast } from "react-toastify";
import config from '../helper/config'
import { socketId } from "../socket";
import { createInstance } from "../Axios/user.axios";
import Chat from "./chat";
import { Reddit } from "@mui/icons-material";
export default function Footer() {
  

    return (

        <>


            <footer class="footer">
                <div class="footer-1">
                    <div class="container">
                        <div class="row">
                            {/* <div class="col-lg-3 width-20">
                                <Link to="#"><div class="mb-10">
                                    <img src={edafacelogo} alt="EdaFace" />
                                </div>
                                </Link>
                                <h6 class="color-brand-1">Our Communities</h6>
                                <div class="mt-15">
                                    <Link class="icon-socials" target="_blank" to=" https://forum.edaface.com/" title="ChatForum">
                                        <img src={chatforum} alt="Chat_Forum" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://discord.com/channels/1030619158435610715/1030619159542898790 " title="Discord">
                                        <img src={discord} alt="Discord" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.facebook.com/EdaFace.Office1" title="Facebook">
                                        <img src={facebook} alt="Facebook" /></Link>
                                        <Link class="icon-socials" target="_blank" to="https://www.instagram.com/edaface_office/" title="Instagram">
                                        <img src={instagram} alt="Instagram" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.reddit.com/user/EdaFace/" title="Reddit">
                                        <img src={reddit} alt="Reddit" /></Link>
                                    <Link class="icon-socials" target="_blank" to="https://t.me/EdaFace_Global_Community" title="Telegram">
                                        <img src={telegram} alt="Telegram" /></Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.tiktok.com/@edaface" title="Tiktok">
                                        <img src={tiktok} alt="Telegram" /></Link>
                                    <Link class="icon-socials" target="_blank" to="https://twitter.com/EdaFace_office" title="Twitter">
                                        <img src={twitter} alt="Twitter" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to=" https://www.youtube.com/@edaface" title="YouTube">
                                        <img src={youtube} alt="YouTube" /></Link>
                                </div></div> */}
                                
                                <div class="col-lg-3 width-16 mb-30">

                                <h5 class="mb-10 color-brand-1">Company</h5>

                                <ul class="menu-footer">
                                    <li><Link to="https://edaface.com/vision" title="Vision" target="_blank">Vision </Link></li>
                                    <li><Link to="https://edaface.com/mission" title="Mission" target="_blank">Mission </Link></li>
                                    <li><Link to="https://edaface.com/core-values" title="Core Values" target="_blank">Core Values</Link></li>
                                    <li><Link to="https://edaface.com/branding" title="Branding" target="_blank">Branding </Link></li>
                                    <li><Link to="https://edaface.com/litepaper" title="Litepaper" target="_blank">Litepaper </Link></li>
                                    <li><Link to="https://edaface.com/whitepaper-1" title="Whitepaper" target="_blank">Whitepaper </Link></li>
                                    <li><Link to="https://info.edaface.com/index.php/knowledge-base/article/nft-team" title="NFT Team" target="_blank">NFT Team </Link></li>
                                    <li><Link to="https://info.edaface.com/index.php/knowledge-base/article/edaface-brochure" title="Career" target="_blank">Career </Link></li>
                                    <li><Link to="https://nft.edaface.com/faq" title="FAQ" target="_blank">FAQ </Link></li>
                                </ul>
                            </div>

                            <div class="col-lg-3 width-16 mb-30">
                                <h5 class="mb-10 color-brand-1">Products</h5>
                                <ul class="menu-footer">
                                    <li><Link to="https://edaface.com/eda-coin" title="EDA Coin" target="_blank">EDA Coin</Link></li>
                                    <li><Link to="https://literature.edaface.com/" title="Blockchain Literature" target="_blank">Blockchain Literature</Link></li>
                                    <li><Link to="https://edaface.com/welfare-donations" title="Charity Donations" target="_blank">Charity Donations </Link></li>
                                    <li><Link to="https://edaface.com/dex" title="EdaFace Dex" target="_blank">EdaFace Dex </Link></li>
                                    <li><Link to="https://mall.edaface.com" title="EdaFace Mall" target="_blank">EdaFace Mall </Link></li>
                                    <li><Link to="https://edaface.com/coin-ranking" title="Listing Platforms" target="_blank">Listing Platforms </Link></li>
                                    <li><Link to="https://edaface.com/newsfeed" title="Newsfeed" target="_blank">Newsfeed </Link></li>
                                    <li><Link to="https://edaface.com/school-of-cryptocurrencies" title="School of Cryptos" target="_blank">School of Cryptos </Link></li>
                                    <li><Link to="https://info.edaface.com/" title="How to Use EdaFace" target="_blank">How to Use EdaFace </Link></li>
                                </ul>
                            </div>

                            <div class="col-lg-3 width-16 mb-30">
                                <h5 class="mb-10 color-brand-1">Legal</h5>
                                <ul class="menu-footer">
                                    <li><Link to="https://info.edaface.com/knowledge-base/article/terms-of-use" title="Term of Use" target="_blank">Term of Use</Link></li>
                                    <li><Link to="https://info.edaface.com/knowledge-base/article/privacy-policy" title="Privacy Policy" target="_blank">Privacy Policy</Link></li>
                                    <li><Link to="https://info.edaface.com/knowledge-base/article/disclaimers" title="Disclaimer" target="_blank">Disclaimer</Link></li>
                                    <li><Link to="https://info.edaface.com/index.php/knowledge-base/article/listing-terms-and-conditions" title="Listing Tc & Cs" target="_blank">Listing Tc & Cs</Link></li>
                                    <li><Link to="https://info.edaface.com/index.php/knowledge-base/article/nft-marketplace-terms-and-conditions" title="NFT Ts & Cs" target="_blank">NFT Ts & Cs</Link></li>
                                    <li><Link to="https://info.edaface.com/index.php/knowledge-base/article/external-creator-agreement" title="External Creators Ts & Cs" target="_blank">External Creators Ts & Cs</Link></li>
                                </ul>
                            </div>

                            <div class="col-lg-3 width-16 mb-30">
                                <h5 class="mb-10 color-brand-1">Contact Admin</h5>
                                <Link to="https://edaface.com/" target="_blank"><div class="mb-10">
                                    <img src={edafacelogo} alt="EdaFace" width='150' />
                                </div>
                                </Link>

                                <p className="font-sm color-grey-400">
                                    <a href="https://edaface.com/contact" target="_blank" className="FooterHeadquater">Headquarter in Pretoria, South Africa</a>
                                </p>

                                <h6 class="color-brand-1 m-0">Social Media</h6>
                                <div>
                                    <Link class="icon-socials" target="_blank" to="https://forum.edaface.com/" title="ChatForum">
                                        <img src={chatforum} alt="Chat_forum" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://discord.com/channels/1030619158435610715/1030619159542898790" title="Discord">
                                        <img src={discord} alt="Discord" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.facebook.com/EdaFace.Office1" title="Facebook">
                                        <img src={facebook} alt="Facebook" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.instagram.com/edaface_office/" title="Instagram">
                                        <img src={instagram} alt="Instagram" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.reddit.com/user/EdaFace/" title="Reddit">
                                        <img src={reddit} alt="Reddit" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://t.me/+8O9tfHSRdEZkY2E0" title="Telegram">
                                        <img src={telegram} alt="Telegram" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.tiktok.com/@edaface" title="Tiktok">
                                        <img src={tiktok} alt="Tiktok" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://twitter.com/EdaFace_office" title="Twitter">
                                        <img src={twitter} alt="Twitter" />
                                    </Link>
                                    <Link class="icon-socials" target="_blank" to="https://www.youtube.com/channel/UCpCIoI_03jXv7rC7DUdCAww" title="YouTube">
                                        <img src={youtube} alt="YouTube" />
                                    </Link>
                                </div>
                                <div className="mt-3">
                                    <a class="btn btn-brand-1 hover-up" href="https://edaface.com/contact" >Contact Us</a>
                                </div>
                                {/* <div className="mt-2">
                                    <a class="btn btn-brand-1 hover-up" href="https://edaface.com/forum" target="_blank">Chat Forum</a>
                                </div> */}
                                <div className="mt-2">
                                    <a class="btn btn-brand-1 hover-up" href="/support">Support</a>
                                </div>
                            </div>

                            <div class="col-lg-3 width-23">

                                <h5 class="mb-10 color-brand-1">Download EdaFace App</h5>

                                <div>
                                    <p className="font-sm color-grey-400">
                                        Our app is your gateway to a seamless and enriched experience, putting the power in your hands. Apps coming soon.
                                    </p>
                                    <div class="mt-20 d-flex">
                                        <a class="pe-2" href="https://www.apple.com/store" target="_blank">
                                            <img src="https://edaface.com/storage/icons/d113d14f-fb22-4e96-90c9-29f725c0d606.webp" alt="Apple Store" />
                                        </a>
                                        <a class="pe-2" href="https://play.google.com/store" target="_blank">
                                            <img src="https://edaface.com/storage/icons/0b62f805-3aef-4465-8911-f2fe0b0836c0.webp" alt="Google Play" />
                                        </a>
                                    </div>
                                    
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="footer-custom">
                    <div class="container">
                        <div class="footer-bottom">
                            <div class="row">
                                <div class="col-lg-12 col-md-12 text-center">
                                    <span class="color-grey-300 font-md">Copyright © <span id="copyright-year">2023</span>. EdaFace is a product of Emerging Digital Age (EDA) Pty Ltd. All Rights Reserved.</span>
                                </div>
                            </div>
                        </div>
                    </div>

                </div>


                {/* <a id="scrollUp" href="#top"><FaArrowUp /></a> */}


                {/* chart code */}
               {/*  <div className="chatbox cursor" onClick={() => { chatfirst(); }}>
                    {chatside ?
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" height="25px" width="25px" role="img" alt="Close icon" class="tawk-min-chat-icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M466.24042,400.4053l272.927-275.99463c6.94586-8.76452,11.13092-20.00501,11.13092-32.20959 s-4.18506-23.42317-11.21857-32.29724l0.08765,0.10955c-8.76453-6.94588-20.005-11.13094-32.20959-11.13094 c-12.20453,0-23.42316,4.18505-32.29724,11.21858l0.10956-0.08765L401.84311,336.008L125.84851,60.0134 c-8.76452-6.94588-20.00501-11.13094-32.2096-11.13094s-23.42316,4.18506-32.29724,11.21858l0.10955-0.08765 C54.50535,68.77792,50.32029,80.01842,50.32029,92.223s4.18505,23.42317,11.21858,32.29724l-0.08764-0.10956l275.9946,275.99463 L61.45122,673.33234c-6.94588,8.76453-11.13094,20.005-11.13094,32.20959s4.18506,23.42316,11.21858,32.29724l-0.08765-0.1095 c8.19483,7.64703,19.2162,12.33606,31.33314,12.33606c0.83263,0,1.68717-0.02191,2.49789-0.06573h-0.10957 c0.54779,0.02191,1.20512,0.04382,1.86246,0.04382c11.32813,0,21.5388-4.71094,28.79144-12.29224l0.0219-0.02191 l275.99463-272.92703l272.92703,272.92703c7.2746,7.58136,17.48523,12.31415,28.81335,12.31415 c0.65735,0,1.29279-0.02191,1.95013-0.04382h-0.08765c0.72308,0.04382,1.55573,0.06573,2.38831,0.06573 c12.11694,0,23.16022-4.68903,31.37695-12.35797l-0.02185,0.02191c6.94586-8.76447,11.13092-20.005,11.13092-32.20959 c0-12.20453-4.18506-23.42316-11.21857-32.29724l0.08765,0.10956L466.24042,400.4053z"></path></svg> :
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 800 800" height="32px" width="32px" role="img" alt="Chat icon" class="tawk-min-chat-icon"><path fill-rule="evenodd" clip-rule="evenodd" d="M400 26.2c-193.3 0-350 156.7-350 350 0 136.2 77.9 254.3 191.5 312.1 15.4 8.1 31.4 15.1 48.1 20.8l-16.5 63.5c-2 7.8 5.4 14.7 13 12.1l229.8-77.6c14.6-5.3 28.8-11.6 42.4-18.7C672 630.6 750 512.5 750 376.2c0-193.3-156.7-350-350-350zm211.1 510.7c-10.8 26.5-41.9 77.2-121.5 77.2-79.9 0-110.9-51-121.6-77.4-2.8-6.8 5-13.4 13.8-11.8 76.2 13.7 147.7 13 215.3.3 8.9-1.8 16.8 4.8 14 11.7z"></path></svg>
                    }
                </div>
                <div className={chatside ? "" : "d-none"}>
                    <div className="chatlist">
                        <h6 className="chat_head mb-0">Support</h6>
                        {!isEmpty(payload?.EmailId) ?
                            <>
                                <div className="chattext_box">
                                    {chattextboxes.map((i) =>
                                        <div className={i.type == "admin" ? "box_left mb-3" : "box_right mb-3"}>
                                            <p className="mb-0">
                                                {i.msg}
                                            </p>
                                        </div>)}
                                </div>
                                <div className="px-2">
                                    <div class="input-group gap-1 mb-2">
                                        <input type="text" class="form-control" onChange={(e) => setMsg(e.target.value)} value={msg} placeholder="Message" aria-label="Recipient's username" aria-describedby="basic-addon2" />
                                        <div class="input-group-append">
                                            <button class="btn btn-brand-1 hover-up sendbtn" type="button"><IoSend /></button>
                                        </div>
                                    </div></div>
                            </> : <>
                                {!verifysteps &&
                                    <div className="full_list">
                                        <Link to="/login"><button class="btn btn-brand-1 hover-up mb-3" type="button">Go to Login</button></Link>
                                        <br></br>
                                        <button class="btn btn-brand-1 hover-up" type="button" onClick={() => setVerifysteps(true)}>Continue as visiter</button>
                                    </div>}
                                {verifysteps &&
                                    <div className="full_list mx-3">
                                        <h6 className="text-start mb-2">Email Id</h6>
                                        <input className="form-control" type="email" onChange={(e) => setEmailId(e.target.value)} placeholder="Email" value={EmailId} />
                                        <button class="btn btn-brand-1 hover-up mt-3" type="button" onClick={() =>goToChat()}>Continue as Chat</button>
                                    </div>}

                            </>}
                    </div>
                </div> */}

                {/* chart code end */}
                <Chat/>

            </footer>

         


        </>
    );
}
